var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    zoomAndPan: "magnify",
    viewBox: "0 0 112.5 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.806711, 23.333204)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 25.78125 0 L 23.6875 0 L 23.6875 -12.5625 L 14.609375 0 L 13.53125 0 L 4.4375 -12.5625 L 4.4375 0 L 2.34375 0 L 2.34375 -16.84375 L 3.921875 -16.84375 L 14.0625 -2.8125 L 24.203125 -16.84375 L 25.78125 -16.84375 Z M 25.78125 0 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.379955, 23.333204)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 21.5 0 L 2.34375 0 L 2.34375 -16.84375 L 21.5 -16.84375 L 21.5 -14.765625 L 4.4375 -14.765625 L 4.4375 -9.46875 L 19.53125 -9.46875 L 19.53125 -7.375 L 4.4375 -7.375 L 4.4375 -2.09375 L 21.5 -2.09375 Z M 21.5 0 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.081338, 23.333204)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.4375 0 L 4.4375 -16.84375 L 2.34375 -16.84375 L 2.34375 0 Z M 4.4375 0 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.31231, 23.333204)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 22.546875 0 L 21.125 0 L 4.4375 -13.59375 L 4.4375 0 L 2.34375 0 L 2.34375 -16.84375 L 3.765625 -16.84375 L 20.453125 -3.234375 L 20.453125 -16.84375 L 22.546875 -16.84375 Z M 22.546875 0 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.5b6f4ba54b14abee7f991886d0b534ea.svg";
export { ForwardRef as ReactComponent };